import { supabase } from '@/integrations/supabase/client';

/**
 * Ends any active eBay listings tied to the given user_items.id values.
 * Safe to call before deleting items — failures are logged but never thrown,
 * so deletion can proceed even if eBay is unreachable.
 */
export async function endEbayListingsForItems(itemIds: string[]): Promise<void> {
	if (!itemIds.length) return;
	try {
		const { data, error } = await supabase
			.from('ebay_listings')
			.select('item_id, status')
			.in('item_id', itemIds);
		if (error) throw error;
		const active = (data ?? []).filter((row) => row.status !== 'ended');
		if (!active.length) return;
		await Promise.allSettled(
			active.map((row) =>
				supabase.functions.invoke('ebay-end-listing', {
					body: { item_id: row.item_id }
				})
			)
		);
	} catch (err) {
		console.warn('endEbayListingsForItems failed (continuing with delete):', err);
	}
}
